import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import * as rsuite from "rsuite";
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';

import axios from 'axios';
import { trackPromise } from "react-promise-tracker";
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CKEditor from "ckeditor4-react";
CKEditor.editorUrl = "/assets/ckeditor/ckeditor.js";



const UpdateParentProp = forwardRef((props, ref) => {

    //#region const 


    const [Id, setId] = useState(General.GuidEmpty());
    const [ShowLoader, setShowLoader] = useState(false);

    const [Code, setCode] = useState("");

    //#endregion

    //#region Methods 




    useImperativeHandle(ref, () => ({
        setId(Id) {
            setId(Id);
        }
    }))



    const handleSubmit = (e) => {
        e.preventDefault();
        if (Code === "") {
            General.ShowMsg(Enum.MsgType.error, "کد والد مقصد را مشخص نمایید");
            return;
        }

        setShowLoader(true);
        var RequestOption = {
            method: 'Post',
            url: General.ApiRoute() + '/Topic/UpdateParentId',
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
            },
            data: {
                "Id": Id,
                "Code": Code
            },
            withCredentials: true
        }
        trackPromise(
            axios(RequestOption)
                .then(function (res) {
                    if (res.data.isSuccess) {

                        General.ShowMsg(Enum.MsgType.success, General.SaveSuccess());
                     
                        setShowLoader(false);

                        props.onSubmit();
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, res.data.error);
                        setShowLoader(false);
                    }

                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            General.ShowMsg(Enum.MsgType.error, General.unAuthorize());


                        }
                        else if (error.response.status === 403) {
                            General.ShowMsg(Enum.MsgType.error, General.AccessDenied());

                        }
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                        setShowLoader(false);
                    }
                })
        )
    };

  

    //#endregion


    return (
        <form onSubmit={handleSubmit}>
          
            <div>
                <label>کد والد مقصد را مشخص نمایید</label>
                <rsuite.Input
                    type="text"
                    value={Code}
                    onChange={value => setCode(value)}
                    required />
            </div>
          

            <rsuite.Divider />
            <div align="left">
                {
                    !ShowLoader ?

                        <rsuite.Button appearance="primary" className="mt-2" onClick={handleSubmit}>
                            ثبت 
                        </rsuite.Button>
                        :
                        <rsuite.Button appearance="primary" className="mt-2" disabled>
                            <rsuite.Loader content="در حال ارسال اطلاعات..." />
                        </rsuite.Button>
                }
            </div>

        </form>
    );
});

export default UpdateParentProp;